import React, { useState } from "react";
import {
    Button,
    Input,
    Row,
    Typography,
    Col,
    Card,
    Select,
    Form,
    Checkbox,
    Divider,
} from "antd";
import CustomButton from "../../../../components/custom/CustomButton";
import TableSystemHooks from "./TableSystemHook";


const { Text, Title } = Typography;
const Search = Input;
const Option = Select;

export default function FormSystemHooks({ onCancel, disabled, setDisabled }) {
    const [formData, setFormData] = useState(null);
    const [currentTemplate, setCurrentTemplate] = useState({ hookTemp: "" });


    const onFinishForm = (values) => {
        console.log(values);
        setFormData(values);
    }


    const [form] = Form.useForm();

    const handleValuesChange = (changedValues, allValues) => {
        setCurrentTemplate(changedValues);
        console.log(currentTemplate);
    }



    return (
        <Form layout="vertical" onFinish={onFinishForm} form={form} initialValues={formData} onValuesChange={handleValuesChange}
        >
            <Card
                style={{
                    boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
                    borderRadius: 20,
                }}

                title={<Title level={3}>Create Hook</Title>}
            >
                <Card
                    style={{
                        marginBottom: "2%",
                        boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
                    }}
                >
                    <Title level={4} style={{ margin: 5 }}>Hook Entity Info</Title>
                    <Divider style={{ marginTop: 0, padding: 0 }} />
                    <Row
                        gutter={{
                            xs: 8,
                            sm: 16,
                            md: 24,
                            lg: 32,
                        }} style={{ justifyContent: "space-between" }}>
                        <Col style={{ paddingTop: 10 }}>
                            <Form.Item
                                label={<Text strong>Hook template</Text>}
                                name="hookTemp"
                                rules={[{
                                    required: true,
                                    message: "Required Field"
                                }]}
                            >
                                <Select
                                    disabled={disabled}
                                    showSearch
                                    placeholder='Select Hook' style={{ width: "30vh" }}
                                >
                                    <Option value={"elasticSearch"}>Elastic Search</Option>
                                    <Option value={"smsBridge"}>SMS Bridge</Option>
                                    <Option value={"web"}>Web</Option>
                                </Select>
                            </Form.Item>
                            <Form.Item
                                label={<Text strong>Display Name</Text>}
                                name="disName"
                                rules={[{
                                    required: true,
                                    message: "Required Field"
                                }]}
                            >
                                <Input
                                    style={{ width: "30vh" }}
                                />
                            </Form.Item>
                            <Form.Item
                                name="active"
                            >
                                <Checkbox>Active</Checkbox>
                            </Form.Item>
                        </Col>
                        <Col style={{ paddingTop: 10 }}>
                            <Form.Item
                                label={<Text strong>Content Type</Text>}
                                name="contenType"
                                rules={[{
                                    required: true,
                                    message: "Required Field"
                                }]}
                            >
                                <Input
                                    showSearch
                                    style={{ width: "30vh" }}
                                />
                            </Form.Item>
                            <div>
                                {(currentTemplate.hookTemp === "elasticSearch") &&
                                    <Form.Item
                                        label={<Text strong>Index Name</Text>}
                                        name="idName"
                                        rules={[{
                                            required: true,
                                            message: "Required Field"
                                        }]}
                                    >
                                        <Input
                                            style={{ width: "30vh" }}
                                        />
                                    </Form.Item>}
                            </div>

                            {(currentTemplate.hookTemp === "smsBridge") &&
                                <div>
                                    <Form.Item
                                        label={<Text strong>Phone Number</Text>}
                                        name="phoneNo"
                                        rules={[{
                                            required: true,
                                            message: "Required Field"
                                        }]}
                                    >
                                        <Input
                                            style={{ width: "30vh" }}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        label={<Text strong>SMS Provider Account Id</Text>}
                                        name="idProvider"
                                        rules={[{
                                            required: true,
                                            message: "Required Field"
                                        }]}
                                    >
                                        <Input
                                            style={{ width: "30vh" }}
                                        />
                                    </Form.Item>

                                </div>
                            }
                        </Col>
                        <Col style={{ paddingTop: 10 }}>
                            <Form.Item
                                label={<Text strong>Payload URL</Text>}
                                name="payload"
                                rules={[{
                                    required: true,
                                    message: "Required Field"
                                }]}
                            >
                                <Input
                                    style={{ width: "30vh" }}
                                />
                            </Form.Item>
                            {(currentTemplate.hookTemp === "smsBridge") &&
                                <div>
                                    <Form.Item
                                        label={<Text strong>SMS Provider</Text>}
                                        name="smsProvider"
                                        rules={[{
                                            required: true,
                                            message: "Required Field"
                                        }]}
                                    >
                                        <Input
                                            style={{ width: "30vh" }}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        label={<Text strong>Provider Token</Text>}
                                        name="tokenProvider"
                                        rules={[{
                                            required: true,
                                            message: "Required Field"
                                        }]}
                                    >
                                        <Input
                                            style={{ width: "30vh" }}
                                        />
                                    </Form.Item>
                                </div>}
                            <Form.Item
                                label={<Text strong>UGD template</Text>}
                                name="ugdTemp"
                            >
                                <Select
                                    showSearch
                                    placeholder='Select Option' style={{ width: "30vh" }}
                                >
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>

                    <Title level={4} style={{ margin: 5 }}>Events Info</Title>
                    <Divider style={{ marginTop: 0, padding: 0 }} />
                    <TableSystemHooks form={form} disabled={disabled} setDisabled={setDisabled} />
                </Card>
                <div
                    hidden={disabled}
                >
                    <Form.Item style={{ margin: 0, padding: 0 }}>
                        <Row>
                            <CustomButton
                                content="Submit"
                                style={{
                                    width: "10%",
                                    marginLeft: "auto",
                                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                                }}
                                htmlType="submit"
                                backgroundColor="#92428B"
                                colorText="white"
                                hoverBackground="#AD4EA7"
                            />
                            <CustomButton
                                content="Cancel"
                                style={{
                                    width: "10%",
                                    marginLeft: "1%",
                                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                                }}
                                backgroundColor="#fff"
                                colorText="black"
                                hoverBackground="#F5F5F5"
                                onClick={onCancel}
                            />
                        </Row>
                    </Form.Item>
                </div>
            </Card>
        </Form >
    );
}
